<template>
  <div v-if="internalValue" id="consultant-edit">
    <div class="vx-row w-full">
      <div class="vx-col w-full lg:w-1/2">
        <DataInput
          v-model="internalValue.name"
          class="w-full mt-4"
          label="Kampagnen Name"
          name="name"
          required
          validation-rules="required"
        />
      </div>
      <div class="vx-col w-full lg:w-1/2">
        <DataInput
          v-model="internalValue.userGroupID"
          :initial-value="internalValue.userGroup"
          type="model"
          class="mt-4"
          label="Benutzergruppe"
          placeholder="Benutzergruppe"
          name="userGroup"
          gql-query="userGroups"
          allow-null
        />
      </div>
    </div>
    <div class="vx-row w-full">
      <div class="vx-col w-full lg:w-1/2">
        <DataInput
          v-model="internalValue.dateStart"
          type="date"
          label="Von"
          placeholder="Von"
          name="dateStart"
          :config="{
            altFormat: 'd.m.Y H:i',
            dateFormat: 'Y-m-d H:i',
            enableTime: true,
            time_24hr: true
          }"
          class="mt-4"
        />
      </div>
      <div class="vx-col w-full lg:w-1/2">
        <DataInput
          v-model="internalValue.dateStop"
          type="date"
          label="Bis"
          placeholder="Bis"
          name="dateStop"
          :config="{
            altFormat: 'd.m.Y H:i',
            dateFormat: 'Y-m-d H:i',
            enableTime: true,
            time_24hr: true
          }"
          class="mt-4"
        />
      </div>
    </div>
    <div class="vx-row w-full">
      <div class="vx-col w-full lg:w-1/2">
        <DataInput
          v-model="internalValue.budget"
          :initial-value="internalValue.budget"
          type="number"
          label="Budget"
          name="budget"
          class="mt-4"
        />
      </div>
    </div>
    <div class="vx-row w-full">
      <div class="vx-col w-full lg:w-1/2">
        <DataInput
          v-model="internalValue.vacancyIDs"
          :initial-value="internalValue.vacancies"
          type="model"
          placeholder="Stellen"
          name="project"
          label="Stellen"
          multiple
          model-label="title"
          gql-query="vacancyPage"
          gql-filter-type="objectFilter"
          object-filter-attribute="searchQuery"
          class="mt-4"
        />
      </div>
      <div class="vx-col w-full lg:w-1/2">
        <DataInput
          v-model="internalValue.facebookAdInsightIDs"
          :initial-value="internalValue.facebookAdInsights"
          type="model"
          label="Facebook Kampagnen"
          placeholder="Facebook Kampagnen"
          name="facebook"
          multiple
          gql-query="facebookAdOverview"
          gql-filter-type="objectFilter"
          object-filter-attribute="search"
          model-label="
          adName"
          :select-label="el => el.adName"
          class="mt-4"
        />
      </div>
      <div class="vx-col w-full lg:w-1/2">
        <DataInput
          v-model="internalValue.cleverreachReportIDs"
          :initial-value="internalValue.cleverreachReports"
          type="model"
          label="Newsletter"
          placeholder="Newsletter"
          name="cleverreach"
          multiple
          gql-query="cleverreachReportOverview"
          gql-filter-type="objectFilter"
          object-filter-attribute="nameSearch"
          class="mt-4"
        />
      </div>
      <div class="vx-col w-full lg:w-1/2">
        <DataInput
          v-model="internalValue.googleAdIDs"
          :initial-value="internalValue.googleAds"
          type="model"
          label="Google Ads"
          placeholder="Google Ads"
          name="googleAds"
          multiple
          gql-query="googleAdOverview"
          gql-filter-type="objectFilter"
          object-filter-attribute="search"
          model-label="
          adGroupName"
          :select-label="el => el.adGroupName"
          class="mt-4"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DataInput from "@/components/ui/DataInput";

export default {
  components: {
    DataInput
  },
  props: {
    own: { type: Boolean, default: false },
    value: { type: Object, required: true }
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  watch: {
    internalValue: {
      deep: true,
      handler: function(v) {
        this.internalValue = v;
      }
    }
  }
};
</script>
